module.exports = __webpack_public_path__ + "img/menu_img1.6e0aff0b.png";